export default __webpack_public_path__ + "static/media/spikes.ab304b3d.png";